import { Component, OnInit, OnChanges } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { iif } from 'rxjs';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario56',
  templateUrl: './formulario56.component.html',
  styleUrls: ['./formulario56.component.css']
})
export class Formulario56Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public arquitectos;
  public registro_bienes;
  public tipo_condominio;
  public reglamento_copropiedad;
  

   pages = [1,2,3];

  constructor() {

  


  }

   ngOnInit(){

   }

   ngAfterContentChecked(){


    this.ngAfterContentInit();
    
  }


   ngAfterContentInit() {
    
  
    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }
    }

    //PROPIETARIOS
    if(JSON.parse(localStorage.getItem("propietarios"))){
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
     }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }
    }

     //PERMISO NOTARIADO
    if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
    }

    //ARQUITECTOS
    if(JSON.parse(localStorage.getItem("arquitectos"))){
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0){
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }else{ 
       localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
      }
    }

     //REGISTRO DE BIENES
     if(JSON.parse(localStorage.getItem("registro_bienes"))){
      if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0){
        this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"))
      }else{ 
       localStorage.setItem("registro_bienes", JSON.stringify([]))
        this.registro_bienes = [{inscrito: '', numero:'', anio:'', bienes:''}]
      }
     }

    //REGISTRO DE BIENES
    if(JSON.parse(localStorage.getItem("tipo_condominio"))){
      if (JSON.parse(localStorage.getItem("tipo_condominio")).length > 0){
        this.tipo_condominio = JSON.parse(localStorage.getItem("tipo_condominio"))
      }else{ 
      localStorage.setItem("tipo_condominio", JSON.stringify([]))
        this.tipo_condominio = [{condominio: ''}]
      }
    }
    
    //REGLAMENTO COPROPIEDAD
    if(JSON.parse(localStorage.getItem("reglamento_copropiedad"))){
      if (JSON.parse(localStorage.getItem("reglamento_copropiedad")).length > 0){
        this.reglamento_copropiedad = JSON.parse(localStorage.getItem("reglamento_copropiedad"))
      }else{ 
      localStorage.setItem("reglamento_copropiedad", JSON.stringify([]))
        this.reglamento_copropiedad = [{notaria_reg_copro: '',fecha_notaria: '',cbr_reg_copro:'',registro_anio:'',fojas_reg_copro:'',numero:''}]
      }
    }
    

  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });
    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }
}

